import { render, staticRenderFns } from "./b_Invoices.vue?vue&type=template&id=8897da18&scoped=true&"
import script from "./b_Invoices.vue?vue&type=script&lang=js&"
export * from "./b_Invoices.vue?vue&type=script&lang=js&"
import style0 from "./b_Invoices.vue?vue&type=style&index=0&id=8897da18&prod&lang=css&"
import style1 from "./b_Invoices.vue?vue&type=style&index=1&id=8897da18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8897da18",
  null
  
)

export default component.exports